import { Info, type LucideIcon } from "lucide-react";

export function FullPageMessage({
  title,
  message,
  icon: Icon = Info,
}: {
  title: string;
  message: string;
  icon?: LucideIcon;
}) {
  return (
    <div className="flex min-h-[calc(100vh-4rem)] w-full items-center justify-center">
      <div className="flex flex-col items-center gap-3 p-4">
        <div className="flex items-center gap-1.5 text-lg font-semibold text-foreground">
          <Icon className="size-5 text-muted-foreground" />
          {title}
        </div>
        <p className="font-mono text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
